import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CONTENTO_TYPES from '../../../../../domain/ContentoTypes.js';
import { THEMES } from '../../../../../ui-components/PlayBadge/PlayBadge';
import { exitFullscreen } from '../../../../../utils/fullscreen';
import { listTrackingPropType } from '../../../../../utils/propTypes';
import { trackCustomEvent } from '../../../../../utils/statistics/clientStatistics';
import { listTrackingEvent } from '../../../../../utils/statistics/customEvents';
import { truncate } from '../../../../../utils/stringutils';
import { createImageProxyUrl } from '../../../../../utils/svtimage';
import VideoProgress from '../../../../CommonElements/VideoProgress';
import OpenArchiveBadge from '../../../../OpenArchiveBadge/OpenArchiveBadge.jsx';
import {
    StyledEndScreenRecommendations,
    StyledHeader,
    StyledItemLink,
    StyledItems,
    StyledThumbnail,
    StyledThumbnailImage,
    StyledThumbnailWrapper,
} from './EndScreen.styles';

class VideoLink extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imageLoaded: false,
        };

        this.onImageLoaded = this.onImageLoaded.bind(this);
    }

    onImageLoaded() {
        this.setState({ imageLoaded: true });
    }

    render() {
        const {
            contentType,
            contentUrl,
            openArchive,
            programTitle,
            title,
            posterImage,
            progress,
            listTracking,
            index,
            svtId,
        } = this.props;

        const { imageLoaded } = this.state;

        if (!contentUrl) {
            return null;
        }

        const heading = contentType === CONTENTO_TYPES.VARIANT ? programTitle : title;

        const subHeading = contentType === CONTENTO_TYPES.VARIANT && title !== programTitle ? title : '';

        const eventData = {
            ...listTracking,
            listItemIndex: index,
            contentId: svtId,
        };

        return (
            <Link href={contentUrl} passHref replace>
                <StyledItemLink
                    onClick={() => {
                        trackCustomEvent(listTrackingEvent(eventData));
                    }}
                    imageLoaded={imageLoaded}
                >
                    <StyledThumbnail>
                        <StyledThumbnailWrapper>
                            <OpenArchiveBadge openArchive={openArchive} theme={THEMES.DEFAULT} />
                            <StyledThumbnailImage
                                src={posterImage}
                                alt=""
                                aria-hidden="true"
                                onLoad={this.onImageLoaded}
                            />
                            <VideoProgress percent={progress} />
                        </StyledThumbnailWrapper>
                    </StyledThumbnail>
                    <StyledHeader as="h2">{truncate(heading, 36)}</StyledHeader>
                    {subHeading && <p className="play_content-item__subtext">{truncate(subHeading, 46)}</p>}
                </StyledItemLink>
            </Link>
        );
    }
}

class EndScreenWithContinueWatching extends Component {
    componentDidMount() {
        exitFullscreen();
    }

    render() {
        const { recommendedItems, listTracking } = this.props;

        return (
            <StyledEndScreenRecommendations>
                <StyledItems data-rt="end-screen-recommendations">
                    {recommendedItems.map((item, i) => {
                        const {
                            item: {
                                __typename,
                                oppetArkiv,
                                name,
                                svtId,
                                restrictions: { onlyAvailableInSweden },
                                urls: { svtplay: contentUrl },
                                parent,
                            },
                            images,
                        } = item;

                        const index = i + 1;
                        const programTitle = parent && parent.name;
                        const posterImage = images
                            ? createImageProxyUrl(images.wide.id, images.wide.changed, 'medium', 480)
                            : null;

                        const progress = item.progressFraction;

                        return (
                            <VideoLink
                                key={index}
                                onlyAvailableInSweden={onlyAvailableInSweden}
                                contentType={__typename}
                                contentUrl={contentUrl}
                                openArchive={oppetArkiv}
                                programTitle={programTitle}
                                title={name}
                                posterImage={posterImage}
                                className={`nth-${index}`}
                                progress={progress}
                                listTracking={listTracking}
                                index={index}
                                svtId={svtId}
                            />
                        );
                    })}
                </StyledItems>
            </StyledEndScreenRecommendations>
        );
    }
}

EndScreenWithContinueWatching.propTypes = {
    recommendedItems: PropTypes.array,
    listTracking: listTrackingPropType,
};

export default EndScreenWithContinueWatching;
